import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const responseSchema = z.object({
  seller_account_name: z.string().nullable(),
  account_region: z.array(z.string()).nullable(),
  amazon_seller_marketplaces: z.array(z.string()).nullable(),
  amazon_profile_ids: z.unknown().nullable(),
  fallback_default_marketplace: z.string(),
});

export const sellerInfoApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getSellerInfo",
    method: "get",
    path: "/sellerinfo",
    status: 200,
    response: responseSchema,
  }).build(),
);
